import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const ROUTE_TITLES = {
  '/about': 'About',
  '/about/beliefs': 'Our Beliefs',
  '/about/leadership': 'Leadership',
  '/sermons': 'Sermons',
  '/events': 'Events',
  '/announcements': 'Announcements',
  '/small-groups': 'Small Groups',
  '/contact': 'Contact',
  '/fellowship': 'Fellowship',
  '/livestream': 'Live Stream',
  '/bulletin': 'Bulletin',
  '/catechisms': 'Catechisms',
  '/podcast': 'Podcast',
  '/blog': 'Blog',
  '/music': 'Music',
  '/give': 'Give',
  '/privacy': 'Privacy Policy',
  '/member/login': 'Sign In',
  '/member/signup': 'Create Account',
  '/member/profile': 'My Profile',
  '/member/preferences': 'Preferences',
  '/member/password': 'Change Password',
  '/member/registrations': 'My Registrations',
  '/member/forgot-password': 'Forgot Password',
  '/member/reset-password': 'Reset Password',
  '/member/verify-email': 'Verify Email',
};

const SITE_NAME = 'CGS';
const DEFAULT_TITLE = 'CGS - The Church Gathered and Scattered';

export default function RouteTitle() {
  const { pathname } = useLocation();
  const title = ROUTE_TITLES[pathname]?.replace('/', '') || '';
  const fullTitle = title ? `${title} - ${SITE_NAME}` : DEFAULT_TITLE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
}
